;(function (angular) {
  'use strict'

  angular.module('kilo.routes.bpu', [
  'kilo.routes.bpu.show',
  'kilo.routes.bpu.edit' ,  
  'kilo.routes.bpu.list' 
  ])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  /**
   *
   */
  function RouteConfigurator ($stateProvider) {
    //
    var parentState = {
      name: 'bpu',
      url: '/bpu',
      abstract: true
    }

    //
    $stateProvider.state(parentState)
  }
})(window.angular)
